export const IMAGE_WIDTH = {
  THUMB: 300,
  CERT_LANDSCAPE: 540,
  CERT_PORTRAIT: 340,
  PRODUCT_LIST: 400,
  SERIES: 600,
  BANNER: 1200,
  DETAIL: 680,
  LARGE: 1600
}

export function optimizeImageUrl(url, width) {
  if (!url) {
    return ''
  }
  if (!width || width <= 0) {
    return url
  }
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}w=${width}`
}
